/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyRemediationBase {
    getFixupPrototypeFunction() { return PolicyRemediationBase.fixupPrototype; }

    static newInstance(model: Partial<PolicyRemediationBase>): PolicyRemediationBase {
        let obj = Object.assign(new PolicyRemediationBase(), model);
        PolicyRemediationBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyRemediationBase>): PolicyRemediationBase {
        if (!model) return null;
        return PolicyRemediationBase.newInstance(<PolicyRemediationBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyRemediationBase) {
        if (!obj) return;

        models.PolicyRemediationBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyRemediationBase): boolean {
        Object.setPrototypeOf(obj, PolicyRemediationBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.schedule_time === undefined) {
            this.schedule_time = 0;
        }
        if (this.args) {
            for (let val of this.args) {
                models.NamedParameter.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the remediation action
     */
    remediation_action_name: string;

    /**
     * Execution parameter values, in the same NamedParameter format as the 'parameters' field in the Get Policy API response. Optionally set a parameter's 'schema.default_value' to override its value for this execution.
     */
    args: Array<models.NamedParameter>;

    /**
     * Delay in seconds after policy execution completes before the auto-remediation action is scheduled to run. For example, a value of 3600 schedules the remediation to run 1 hour after the policy execution finishes.
     */
    schedule_time: number;

}
